import { Box, Button, Typography } from 'fbm-ui';
import { Stack } from 'fbm-ui/lib/mui';
import { WarningIcon } from 'fbm-icons';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';

const StreamErrorPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const errorMessage =
    searchParams.get('message') || t('视频推流异常，请检查网络和设备状态');
  const interviewToken = searchParams.get('token') || '';

  const handleRetry = () => {
    // 返回面试页面并重试
    navigate(`/interview/ai/${interviewToken}`, { replace: true });
  };

  const handleExit = () => {
    // 返回首页
    navigate('/', { replace: true });
  };

  return (
    <Box
      width={1}
      height="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      sx={{ background: '#F9FAF9' }}
    >
      <Box
        p={4}
        bgcolor="white"
        borderRadius={2}
        // boxShadow={3}
        maxWidth={560}
        width="90%"
      >
        <Stack spacing={3} alignItems="center">
          {/* 警告图标 */}
          <WarningIcon
            sx={{
              fontSize: 64,
              color: 'warning.main',
            }}
          />

          {/* 标题 */}
          <Typography variant="h5" fontWeight="bold" textAlign="center">
            {t('设备异常，面试已暂停')}
          </Typography>

          {/* 错误信息 */}
          <Typography variant="body1" color="text.secondary" textAlign="center">
            错误码: {errorMessage}
          </Typography>

          {/* 检查列表 */}
          <Box width={1}>
            <Typography variant="body2" color="text.secondary" mb={1.5}>
              {t('为保证面试视音频完整性，请检查以下内容：')}
            </Typography>
            <Stack spacing={1} pl={2}>
              <Typography variant="body2" color="text.secondary">
                • {t('网络连接是否正常')}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                • {t('摄像头和麦克风是否正常工作')}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                • {t('浏览器是否允许访问摄像头和麦克风')}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                • {t('是否有其他程序占用摄像头或麦克风')}
              </Typography>
            </Stack>
          </Box>

          {/* 操作按钮 */}
          <Stack direction="row" spacing={2} width={1} pt={2}>
            {/* <Button
              fullWidth
              variant="outlined"
              color="inherit"
              onClick={handleExit}
            >
              {t('退出面试')}
            </Button> */}
            <Button fullWidth variant="contained" onClick={handleRetry}>
              {t('继续面试')}
            </Button>
          </Stack>

          {/* 提示信息 */}
          <Typography
            variant="caption"
            color="text.disabled"
            textAlign="center"
          >
            {t('如问题持续存在，请联系技术支持或稍后重试')}
          </Typography>
        </Stack>
      </Box>
    </Box>
  );
};

export default StreamErrorPage;
